import { CircularProgressBar } from '@openhouse-engineers/rrc'
import React from 'react'

import Tooltip2 from 'components/common/Tooltip2.0'

import { Container, tooltipStyles } from './styles'

const Progress = ({
    userId,
    isTeacher,
    percentage,
    color,
    onClick,
    ...props
}) => {
    return (
        <Tooltip2
            placement="bottom"
            content="babble meter"
            customCss={tooltipStyles}
            onClick={onClick}
            className="hover-here"
        >
            <Container {...props}>
                <CircularProgressBar
                    bgStrokeColor="#ffffff5c"
                    percentage={percentage}
                    progressStrokeColor={color}
                    showText={false}
                    strokeWidth={20}
                />
                <img src="/assets/revamp/ttm.svg" alt="ttm-icon" />
            </Container>
        </Tooltip2>
    )
}

export default Progress
